import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/sentry";

// Initialise error reporting before the React tree renders so early errors
// (bootstrap, module load) are also captured. No-op when DSN isn't set.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
